"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const bignumber_js_1 = __importDefault(require("bignumber.js"));
const NUM_DECIMALS = 18;
class AccountBalance {
    constructor(value) {
        this.value = new bignumber_js_1.default(value);
    }
    toDenominated() {
        return this.value.shiftedBy(-NUM_DECIMALS);
    }
    toDenominatedString(decimalPlaces = 3) {
        return this.toDenominated().decimalPlaces(decimalPlaces).toString();
    }
    toPrettyString(decimalPlaces = 3) {
        return this.toDenominatedString(decimalPlaces);
    }
    toString() {
        return this.value.toString();
    }
}
exports.default = AccountBalance;
;
